import React from 'react'
// import loader from './loader';
import { RefObject } from 'react';
import { PlayerState } from 'context/PlayerContext';

interface IAzurePlayerProps {
	source: string;
	duration: number;
	playerState: PlayerState;
	setPositionAudio: React.Dispatch<React.SetStateAction<number>>;
	setDurationAudio: React.Dispatch<React.SetStateAction<number>>;
	manualPosition: number | undefined;
}

declare const window: any;

export default class AppleiOSPlayer extends React.Component<IAzurePlayerProps, any> {
	audioNode: RefObject<HTMLAudioElement>;
	playPromise: Promise<void> | null = null; // Tracks the play promise
	constructor(props: IAzurePlayerProps) {
		super(props);
		this.audioNode = React.createRef();
	}

	componentWillUnmount() {
		if (this.audioNode.current) {
			this.audioNode.current.removeEventListener(
				"durationchange",
				this._updateDuration
			);
			this.audioNode.current.removeEventListener(
				"timeupdate",
				this._updatetime
			);
		}
	}

	componentDidMount() {
		if (this.audioNode.current) {
			this.audioNode.current.addEventListener(
				"timeupdate",
				this._updatetime.bind(this)
			);
			this.audioNode.current.addEventListener(
				"durationchange",
				this._updateDuration.bind(this)
			);
		}
		this._setAudio();
	}

	componentDidUpdate(prevProps: IAzurePlayerProps) {
		if (prevProps.playerState !== this.props.playerState) {
			if (this.props.playerState === PlayerState.playing) {
				this.playAudio();
			}
			if (this.props.playerState === PlayerState.paused) {
				this.pauseAudio();
			}
		}

		if (
			this.props.manualPosition !== undefined &&
			prevProps.manualPosition !== this.props.manualPosition
		) {
			this.seekToPosition(this.props.manualPosition);
		}

		if (prevProps.source !== this.props.source) {
			this._setAudio();
		}
	}

	playAudio = async () => {
		if (this.audioNode.current) {
			try {
				this.playPromise = this.audioNode.current.play();
				await this.playPromise;
			} catch (e) {
				// console.error("Play error:", e);
				setTimeout(() => this.playAudio(), 500); // Retry after 500ms
			}
		}
	};

	/** Pause function that waits for play to resolve before pausing */
	pauseAudio = () => {
		if (this.audioNode.current) {
			if (this.playPromise) {
				this.playPromise
					.then(() => {
						if (this.audioNode.current) {
							this.audioNode.current.pause();
						}
					})
					.catch(() => {
						setTimeout(() => this.pauseAudio(), 500); // Retry pause after 500ms
					});
			} else {
				this.audioNode.current.pause();
			}
		}
	};

	/** Seek to a specific position in the audio */
	seekToPosition = (position: number) => {
		if (this.audioNode.current) {
			this.audioNode.current.pause();
			this.audioNode.current.currentTime = position;
			this.playAudio();
		}
	};

	_updatetime = () => {
		if (this.audioNode.current) {
			this.props.setPositionAudio(this.audioNode.current.currentTime);
		}
	};

	_fetchAndParseM3U8 = async (url: string) => {
		try {
			const response = await fetch(url);
			const text = await response.text();

			// Parse the m3u8 file line by line
			const lines = text.split("\n");
			var duration = 0;
			for (let line of lines) {
				if (line.startsWith("#EXT-X-TARGETDURATION:")) {
					duration = parseInt(line.split(":")[1], 10); // Extract the duration
					break;
				}
			}
			this.props.setDurationAudio(duration);
		} catch (error) {
			// console.error("Error fetching or parsing the .m3u8 file:", error);
		}
	}

	async _updateDuration() {
		try {
			this.props.setDurationAudio(this.props.duration)
		}
		catch (err) {
			// console.log("Duration error", err)
		}
	}

	_setAudio() {
		try {
			const appl = this.props.source.replace('(format=mpd-time-csf)', '(format=m3u8-cmaf)')
			//console.log('apple ' + appl);
			if(this.audioNode.current) this.audioNode.current.src = appl;
			// use this for testing as the stream will now only work in apple ios
			//this.audioNode.current.src = 'https://filesamples.com/samples/audio/mp3/Symphony%20No.6%20(1st%20movement).mp3'

		} catch (err) {
			// console.log('Set Episode Error: ', err);
		}
	}

	render() {
		return (
			<div>
				<audio autoPlay={false} ref={this.audioNode} />
			</div>
		);
	}
}
